import React, { Component } from 'react'

import { Switch, Redirect } from 'react-router-dom'
import { articleLookup } from 'constants/Settings'

import SettingsNav from 'components/SettingsNav'
import BasicSettings from 'components/nSettings/BasicSettings'
import LookAndFeelSettings from 'components/nSettings/LookAndFeelSettings'
import AdvancedSettings from 'components/nSettings/AdvancedSettings'
import BotSettings from 'components/nSettings/BotSettings'
import SettingsPageHeader from 'components/nSettings/SettingsPageHeader'
import SettingsPageFooter from 'components/nSettings/SettingsPageFooter'

import { PrivateRoute } from 'utils/routing'

import './style.css'

class nSettings extends Component {
  render() {
    const { match } = this.props
    const linkUrl = match.params.settingPage !== articleLookup ? 'https://help.drift.com/article/customize-drift-help/' : 'https://help.drift.com/article/help-driftbot/'

    return (
      <div className="settings-page-wrapper">
        <h2>Drift Help Settings</h2>
        <div className="settings-page-container">
          <SettingsNav match={match}/>
          <div className="settings-page-content-wrapper">
            <div className="settings-page-content">
              <SettingsPageHeader linkUrl={linkUrl} match={match}/>
              <Switch>
                <Redirect exact from='/settings' to='/settings/the-basics'/>
                <PrivateRoute path='/settings/the-basics' component={BasicSettings}/>
                <PrivateRoute path='/settings/look-and-feel' component={LookAndFeelSettings}/>
                <PrivateRoute path='/settings/advanced' component={AdvancedSettings}/>
                <PrivateRoute path='/settings/lookup' component={BotSettings}/>
              </Switch>
              { match.params.settingPage !== articleLookup &&
                <SettingsPageFooter/>
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default nSettings